export const config = {
    ENVIRONMENT: process.env.REACT_APP_ENV,
    OBO_URL: process.env.REACT_APP_OBO_URL
};